import * as React from 'react';
import type { ComboSelectorPartialBaseProps } from '../../types';
import { Radio } from '~/Partials/RadioGroup/Radio/Radio';
import { RadioGroup } from '~/Partials/RadioGroup/RadioGroup';
import styles from './ComboSelectorRadioGroup.module.css';

interface ComboSelectorRadioGroupProps extends ComboSelectorPartialBaseProps {
    name: string;
}

export const ComboSelectorRadioGroup: React.FC<ComboSelectorRadioGroupProps> = props => {
    const { name, labelId, onChange, options, colorVariant, currentValue } = props;

    const radioVariant = colorVariant === 'light' ? 'light' : 'default';

    return (
        <RadioGroup name={name} onChange={onChange} currentValue={currentValue} aria-describedby={labelId}>
            <div className={styles.ComboSelectorRadioGroupWrapper}>
                {Array.from(options).map(([value, radioLabel]) => (
                    <Radio
                        className={styles.Radio}
                        label={radioLabel}
                        value={value}
                        variant={radioVariant}
                        key={value}
                    />
                ))}
            </div>
        </RadioGroup>
    );
};
